export const PRODUCT_QUANTITY_DEFAULT = 2;
export const PRODUCT_INTERVAL_DEFAULT = 14;
export const PRODUCT_REPEATS_DEFAULT = 4;

export const PRODUCT_ATTRIBUTE_RANGE_DEFAULT_MINIMUM = 0;
export const PRODUCT_ATTRIBUTE_RANGE_DEFAULT_MAXIMUM = 0;

export const PRODUCT_ALERT_MESSAGE_TEMPLATE_REISSUE =
  ' has been reissued based on the selection of previous prescriptions';
